// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__6XQdX","hidden":"modal_hidden__sjocf","modal":"modal_modal__-s-FE","content":"modal_content__ynUuS","closeButton":"modal_closeButton__IA7Vz"};